export default __webpack_public_path__ + "pencil2d.cec149fc.png";